export default __webpack_public_path__ + "static/media/Gg.7f638deb.wav";